import { getRequest } from "../system/server-calls";
import responseHandler from "../system/server-response-handler";

const getAllCountries = () => {
  return getRequest("Countries").then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getAllStates = (countryId) => {
  return getRequest(`Countries/States?countryId=${countryId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};
const getAllCities = (stateId) => {
  return getRequest(`Countries/Cities?stateId=${stateId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getAllLanguages = () => {
  return getRequest(`Languages`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const countryService = {
  getAllCountries,
  getAllStates,
  getAllCities,
  getAllLanguages,
};
